export const tableColumns = [
  { title: "REQ Id", field: "reqId" },
  { title: "Kit Id", field: "kitId" },
  { title: "Booking Id", field: "bookingId" },
  { title: "Patient", field: "name" },
  { title: "Birth Date", field: "dob" },
  { title: "Email", field: "email" },
  { title: "Location", field: "careLocation" },
  { title: "Clinician", field: "clinicianName" },
  { title: "Lab", field: "labName" },
  { title: "Panel/Test", field: "panelName" },
  { title: "Collected Date-Time", field: "sampleTakenDate" },
  { title: "Action", field: "action" }
];
